/**
* @file city switch
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'antd/lib/button';
import Icon from 'antd/lib/icon';
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown';
import getCityInfo from './lib/getCityInfo'
import { Link } from 'react-router-dom';

const a = React.createFactory('a');
const link = React.createFactory(Link);
const button = React.createFactory(Button);
const menu = React.createFactory(Menu);
const menuItem = React.createFactory(Menu.Item);
const dropdown = React.createFactory(Dropdown);
const icon = React.createFactory(Icon);

const overlay = menu(
  null,
  menuItem(null, link({
    to: '/berlin'
  }, 'Berlin')),
  menuItem(null, link({
    to: '/brussels'
  }, 'Brussels')),
  menuItem(null, link({
    to: '/seattle'
}, 'Seattle')),
  menuItem(null, a({
    href: 'http://eepurl.com/cWSrsj',
    target: '_blank'
  }, 'Other Cities'))
);

class City extends Component {
  render() {
    const {city} = this.props;
    if (!city) {
      return null;
    }
    return dropdown(
      {overlay},
      button(
        {},
        getCityInfo(city).name,
        icon({type: 'down'})
      )
    );
  }
}

export default connect(
  ({city}) => {
    return {city};
  }
)(City);



// WEBPACK FOOTER //
// ./src/City.js